// extracted by mini-css-extract-plugin
export default {"sub_header":"subHeader_sub_header__bpfuE","content_end_mark":"subHeader_content_end_mark__c9E+P"};